import android from '../svgs/android.svg';
import caminhao from '../svgs/caminhao.svg';
import disney from '../svgs/disney.svg';
import estrela from '../svgs/estrela.svg';
import gasolina from '../svgs/gasolina.svg';
import moto from '../svgs/moto.svg';

export const items = [
   { name: 'android', icon: android },
   { name: 'caminhao', icon: caminhao },
   { name: 'disney', icon: disney },
   { name: 'estrela', icon: estrela },
   { name: 'gasolina', icon: gasolina },
   { name: 'moto', icon: moto },
];
